import React, { useContext, useState } from "react";
import { MovieContext } from "../contexts/MovieContext";

export default function NewMovieForm() {
  const [title, setTitle] = useState("");
  const [director, setDirector] = useState("");
  const { dispatch } = useContext(MovieContext);

  function handleSubmit(ev) {
    ev.preventDefault();
    dispatch({
      type: "ADD_MOVIE",
      book: {
        title,
        director
      }
    });
    setTitle("");
    setDirector("");
  }
  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        required
        placeholder="Movie Title"
        value={title}
        onChange={e => setTitle(e.target.value)}
      />
      <input
        type="text"
        required
        placeholder="Director"
        value={director}
        onChange={e => setDirector(e.target.value)}
      />
      <input type="submit" value="Add Movie" />
    </form>
  );
}
